import { h, RectNode, RectNodeModel } from '@logicflow/core'

class MenuTaskModel extends RectNodeModel {
  static extendKey = 'MenuTaskModel'
  
  constructor(data, graphModel) {
    // 处理文本格式
    if (!data.text) {
      data.text = ''
    }
    if (data.text && typeof data.text === 'string') {
      data.text = {
        value: data.text,
        x: data.x,
        y: data.y
      }
    }
    super(data, graphModel)
    this.width = data.properties.width ? data.properties.width : 140
    this.height = data.properties.height ? data.properties.height : 60
  }

  getNodeStyle() {
    const style = super.getNodeStyle()
    style.stroke = '#409eff'
    style.strokeWidth = 2
    style.fill = '#ecf5ff'
    
    // 禁用状态（无权限）
    if (this.properties.disabled === true || this.properties.hasPermission === false) {
      style.stroke = '#dcdfe6'
      style.strokeWidth = 1
      style.fill = '#f5f7fa'
      style.opacity = 0.6
    }
    // 高亮状态
    else if (this.properties.state === 'active') {
      style.stroke = '#67c23a'
      style.fill = '#f0f9ff'
    } else if (this.properties.state === 'history') {
      style.stroke = '#909399'
      style.fill = '#f4f4f5'
    }
    
    return style
  }
  
  getTextStyle() {
    const style = super.getTextStyle()
    
    // 禁用状态下文字颜色变灰
    if (this.properties.disabled === true || this.properties.hasPermission === false) {
      style.color = '#c0c4cc'
    }
    
    return style
  }
}

class MenuTaskView extends RectNode {
  static extendKey = 'MenuTaskNode'
  
  getLabelShape() {
    const { model } = this.props
    const { x, y, width, height } = model
    const style = model.getNodeStyle()
    
    // 使用 foreignObject 来渲染 Element UI 图标
    return h(
      'foreignObject',
      {
        x: x - width / 2 + 5,
        y: y - height / 2 + 5,
        width: 20,
        height: 20
      },
      [
        h('div', {
          xmlns: 'http://www.w3.org/1999/xhtml',
          style: {
            width: '20px',
            height: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        }, [
          h('i', {
            class: 'el-icon-s-tools',
            style: {
              fontSize: '18px',
              color: style.stroke
            }
          })
        ])
      ]
    )
  }

  getShape() {
    const { model } = this.props
    const { x, y, width, height, radius } = model
    const style = model.getNodeStyle()
    
    return h('g', {}, [
      h('rect', {
        ...style,
        x: x - width / 2,
        y: y - height / 2,
        rx: radius || 4,
        ry: radius || 4,
        width,
        height
      }),
      this.getLabelShape()
    ])
  }
}

const MenuTask = {
  type: 'flow:menutask',
  view: MenuTaskView,
  model: MenuTaskModel
}

export { MenuTaskView, MenuTaskModel }
export default MenuTask
